// Maps a user's StaffMember roles to the private area they should land in.
const ROLE_HOME = {
  team_manager: "/team",
  team_assistant: "/team",
  parent: "/team",
  organiser: "/admin",
  finance: "/admin",
  operations_admin: "/admin",
  logistics: "/admin",
  score_keeper: "/staff",
  organization_owner: "/admin",
  organization_admin: "/admin",
  operations: "/admin",
  scorekeeper: "/staff",
  guardian: "/team",
};

// All distinct areas a user with several roles can reach (for the area switcher).
export function homesForRoles(roles) {
  const seen = new Set();
  const order = ["/team", "/admin", "/staff"];
  order.forEach((home) => {
    if (roles.some((r) => ROLE_HOME[r] === home)) seen.add(home);
  });
  return [...seen];
}

// Where should this user land after login?
export async function resolveHomeFor(base44, user) {
  const directHomes = homesForRoles(user?.roles || []);
  if (directHomes.length) return directHomes[0];
  try {
    const { items } = await base44.entities.StaffMember.filter({ user_email: user.email }, { limit: 20 });
    const homes = homesForRoles(items.map((s) => s.role));
    if (homes.length) return homes[0];
  } catch (e) {
    /* if the lookup fails, fall back to the account role below */
  }
  if (user.role === "admin") return "/admin";
  return "/team";
}
